<template>
    <button
        :style="{ background: $Utils.colors[color] }"
        @click="$emit('click', $event)"
    >
        <div
            style="display: flex; align-items: center; justify-content: center"
        >
            <div :class="{ '-hidden': loading }">{{ $t(label) }}</div>
            <i
                class="material-icons"
                :class="{ '-margin': label, '-hidden': loading }"
                v-if="materialIcon"
                >{{ materialIcon }}</i
            >
            <template v-if="loading && !task">
                <div class="button-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </template>
        </div>
    </button>
</template>

<script>
export default {
    name: 'ActionButton',
    props: {
        label: String,
        hint: String,
        color: String,
        customIcon: String,
        materialIcon: String,
        notif: Boolean,
        task: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            showHint: false,
            hintOffset: false,
            top: '0px',
            left: '0px'
        }
    },
    methods: {
        setBody(top, left) {
            if (!this.$refs.timeBody) {
                return
            }
            let largestHeight =
                window.innerHeight - this.$refs.timeBody.offsetHeight - 25
            let largestWidth =
                window.innerWidth - this.$refs.timeBody.offsetWidth - 25
            if (top > largestHeight) {
                top = largestHeight
            } else {
                top = top - this.$refs.timeBody.offsetHeight - 15
            }
            if (left > largestWidth) {
                left = largestWidth
            } else {
                left = left - this.$refs.timeBody.offsetWidth / 2
            }
            this.top = `${top}px`
            this.left = `${left}px`
        },
        hideHint() {
            this.showHint = false
            this.hintOffset = false
        },
        openHint($event) {
            if (!this.hint) {
                return
            }
            this.hintOffset = true
            setTimeout(() => {
                if (this.hintOffset == true) {
                    this.showHint = true
                    this.$nextTick(() => {
                        this.setBody($event.pageY, $event.clientX)
                    })
                    $event.preventDefault()
                }
            }, 300)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
button {
    color: $light-accent;
    padding: 0.2rem 1rem;
    border-radius: 5rem;
    cursor: pointer;
    font-size: 1.1rem;
    transition: $ease;
    user-select: none;
    font-family: $input-family;
    background: $action-accent;
    align-items: center;
    justify-content: space-between;
    min-height: 2.4rem;
    display: inline;
    position: relative;

    @media (max-width: 1300px) {
        font-size: 1rem;
        padding: 0.2rem 0.8rem;
        min-height: 2rem;
    }

    &:not(:first-of-type) {
        margin-left: 1rem;
    }

    &:hover {
        transform: translateY(0.1rem);
    }
}
button i {
    font-size: 1.7rem;

    &.-margin {
        margin-left: 0.5rem;
    }

    @media (max-width: 1300px) {
        font-size: 1.2rem;
        margin-left: 0.2rem;
    }
}
.button-action img {
    height: 1.3rem;
}
.hint-area {
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5000;
}
.hint {
    position: fixed;
    max-width: 300px;
    background: rgb(100, 100, 100);
    border-radius: 5px;
    padding: 5px;
    font-size: 0.8rem;
    color: #fff;
    pointer-events: none;
    outline: none;
    z-index: 5000;
}
.hint p {
    display: inline;
}
.icon {
    &.-icon-medium {
        height: 20px !important;
        margin-bottom: -3px;
    }
}
.accept-icon {
    height: 12px !important;
}
.notif {
    height: 0.8rem;
    width: 0.8rem;
    background: $gradient-red;
    border-radius: 100%;
    position: absolute;
    right: 0px;
    top: -0.3rem;
    box-shadow: $object-shadow;
    border: solid #fff 0.1rem;
    animation: pulse 1s linear 2s infinite alternate;
}
@keyframes pulse {
    0% {
        transform: scale(1);
    }
    80% {
        transform: scale(1.1);
    }
}
.smaller {
    height: 1rem !important;
}
.-hidden {
    opacity: 0;
}
.button-loader {
    width: 64px;
    height: 11px;

    display: inline-block;
    position: absolute;
}
</style>
